var moment = require('moment')

export default {
    methods: {
        // Determine if empty
        empty: function (obj) {
            return _.isEmpty(obj)
        },

        arrayify: function (value) {
            if (typeof value === "undefined") {
                return []
            }

            return Array.isArray(value) ? value : [value]
        },

        truncate: function (value, at = 30) {
            if (value.length <= at) {
                return value
            }

            return value.substring(0, at) + '...'
        },

        formatDate: function (obj, prop, format='YYYY-MM-DD') {
            if (obj[prop] && obj[prop].value) {
                return moment(obj[prop].value[0][0].value).format(format)
            }

            return false
        },

        // Concatinate values in given object property
        concatProps: function (obj, prop, join_str) {
            var result = []

            if (!obj[prop]) {
                return ''
            }

            // If the property value is an array iterate over it
            if (Array.isArray(obj[prop].value)) {
                obj[prop].value.forEach(function (property) {

                    // If the property is an array iterate and concat
                    if (Array.isArray(property)) {
                        property.forEach(function (value) {
                            if (value.value != '') {

                                if (Array.isArray(value.value)) {
                                    result = result.concat(value.value)
                                } else {
                                    result.push(value.value)
                                }
                            }
                        })
                    } else {
                        // If the property isnt an array just concat
                        if (property != '') {
                            result.push(property)
                        }
                    }

                })
            } else {
                // property value is just a string
                result.push(obj[prop].value)
            }

            return result.join(join_str)
        },


        formatDate: function (obj, prop, format='YYYY-MM-DD') {
            if (obj[prop] && obj[prop].value) {
                return moment(obj[prop].value[0][0].value).format(format)
            }

            return false
        },
        processArchiveNumber: function(obj, prop) {
            var number = '';
            if (obj[prop] && obj[prop].value) {
                number = obj[prop].value[0][0].value;
            }

            // Get view non web ready cookie. If it is present then
            var name = "view_non_web_ready=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    var cookie = c.substring(name.length, c.length)

                    if (cookie == 'true') {
                        number = number.replace("/", "-");
                        return number.replace("#", "-");
                    }
                }
            }

            return number;
        }
    }
}
